import { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useAuth } from './auth';
import { setAnalyticsPersonProperties } from './analytics';

const ACCOUNT_ANALYTICS_QUERY = gql`
  query AccountAnalyticsTraits {
    getAccount {
      plan
      hasBilling
    }
  }
`;

/**
 * Syncs account plan / billing traits to Mixpanel + PostHog person profiles.
 * Mount inside authenticated layouts (e.g. Dashboard).
 */
export function AccountAnalyticsSync() {
  const { user } = useAuth();
  const { data } = useQuery(ACCOUNT_ANALYTICS_QUERY, {
    ssr: false,
    skip: !user,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  useEffect(() => {
    const account = data?.getAccount;
    if (!account) {
      return;
    }
    setAnalyticsPersonProperties({
      plan: account.plan,
      has_billing: account.hasBilling,
    });
  }, [data?.getAccount?.plan, data?.getAccount?.hasBilling]);

  return null;
}
